export const environment = {
  production: false,
  apiUrl: 'https://pos-qa.coricraft.co.za/', // Coricraft POS QA
  // apiUrl: 'https://localhost:44352/', // Coricraft POS QA
  appVersion: '4.14.0',
  apiVersion: 'v1',
  appCode: 'PORTAL-BASE',
  mainMenuKey: 'MAIN',
  toolbarHeight: 64,
  tableMarginBottom: 0,
  reportPath: "api/reports",
  subfolder: '',
  tfgCustomerPortal: 'http://172.26.59.104/StoreManagement/',
  tfgStoreApplicationPortal: 'https://www.tfgqa.co.za/store-application',
  tfgCardReplenPortal: 'http://tst-apps5.ho.fosltd.co.za/StoreManagement/Home/BranchSelect'
};
